import styled from 'styled-components';

export const StyledSubtitle = styled.p`
    text-align: center;
    margin-bottom: ${({ theme }) => theme.space[40]};
    margin-top: ${({ theme }) => theme.space[24]};
    font-size: ${({ theme }) => theme.fontSize.xxlg};
    color: ${({ theme }) => theme.color.grey[30]};
`;
